/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
import { h } from "@stencil/core";
import { InteractiveContainer, updateHostInteraction, } from "../../utils/interactive";
import { logger } from "../../utils/logger";
logger.deprecated("component", {
    name: "tile-select-group",
    removalVersion: 4,
    suggested: ["tile", "tile-group"],
});
/**
 * @deprecated Use the `calcite-tile-group` component instead.
 * @slot - A slot for adding `calcite-tile-select` elements.
 */
export class TileSelectGroup {
    constructor() {
        this.disabled = false;
        this.layout = "horizontal";
    }
    //--------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    //--------------------------------------------------------------------------
    componentDidRender() {
        updateHostInteraction(this);
    }
    render() {
        return (h(InteractiveContainer, { key: '7ecdf608b21ec8854addcb9138e2540af1fb90f5', disabled: this.disabled }, h("slot", { key: '67187ad6c8e5dd195cd2e905cfc78810b7566343' })));
    }
    static get is() { return "calcite-tile-select-group"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tile-select-group.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tile-select-group.css"]
        };
    }
    static get properties() {
        return {
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "When `true`, interaction is prevented and the component is displayed with lower opacity."
                },
                "attribute": "disabled",
                "reflect": true,
                "defaultValue": "false"
            },
            "layout": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TileSelectGroupLayout",
                    "resolved": "\"horizontal\" | \"vertical\"",
                    "references": {
                        "TileSelectGroupLayout": {
                            "location": "import",
                            "path": "./interfaces",
                            "id": "src/components/tile-select-group/interfaces.ts::TileSelectGroupLayout"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the layout of the component.\n\nUse `\"horizontal\"` for rows, and `\"vertical\"` for a single column."
                },
                "attribute": "layout",
                "reflect": true,
                "defaultValue": "\"horizontal\""
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=tile-select-group.js.map
